import IconButton from "@mui/material/IconButton";
import MarkAsUnreadIcon from "@mui/icons-material/MarkAsUnread";
import GoogleIcon from "@mui/icons-material/Google";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import { useState } from "react";
import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  SvgIcon,
} from "@mui/material";
import {
  google,
  outlook,
  office365,
  yahoo,
  CalendarEvent,
} from "calendar-link";
import YahooIcon from "./YahooIcon";

const AddToCalendarButton = ({
  id,
  title,
  description,
  start,
}: {
  id: string;
  title: string;
  description: string;
  start: Date;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const event: CalendarEvent = {
    uid: id,
    title,
    description,
    start,
    duration: [1, "hour"],
  };

  const handleAddToCalendar = (calendarLink: string) => {
    setTimeout(() => {
      window.open(calendarLink, "_blank");
    }, 0);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <EditCalendarIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            handleAddToCalendar(google(event));
          }}
        >
          <ListItemIcon>
            <GoogleIcon />
          </ListItemIcon>
          <ListItemText>Add to Google Calendar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleAddToCalendar(outlook(event));
          }}
        >
          <ListItemIcon>
            <MarkAsUnreadIcon />
          </ListItemIcon>
          <ListItemText>Add to Outlook Calendar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleAddToCalendar(office365(event));
          }}
        >
          <ListItemIcon>
            <MicrosoftIcon />
          </ListItemIcon>
          <ListItemText>Add to Office 365 Calendar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleAddToCalendar(yahoo(event));
          }}
        >
          <ListItemIcon>
            <YahooIcon />
          </ListItemIcon>
          <ListItemText>Add to Yahoo Calendar</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default AddToCalendarButton;
